"use client";

import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";


const API_URL = process.env.REACT_APP_API_URL ||  "http://localhost:4000";

const AdminAuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);

    // ============================================
    // Restore session from HttpOnly cookie
    // ============================================
    useEffect(() => {

        const fetchUser = async () => {

            try {

                console.log("Checking authentication...");

                const response = await fetch(`${API_URL}/projects/admin-me`, {
                    method: "GET",
                    credentials: "include",
                });

                console.log("/projects/admin-me status:", response.status);

                if (!response.ok) {
                    setUser(null);
                    return;
                }

                const data = await response.json();

                console.log("Authenticated user:", data.user);

                setUser(data.user);

            } catch (error) {

                console.error(
                    "Failed to restore authentication:",
                    error
                );

                setUser(null);

            } finally {

                setLoadingAuth(false);

            }
        };

        fetchUser();

    }, []);


    // ============================================
    // Login
    // ============================================
    const login = (userData) => {

        // Backend has already created:
        //
        // token = HttpOnly cookie
        //
        // We DO NOT:
        // - store token in localStorage
        // - create document.cookie
        // - keep JWT in React state

        setUser(userData);

        window.location.href = "/home";
    };


    // ============================================
    // Logout
    // ============================================
    const logout = async () => {

        try {

            await fetch(`${API_URL}/projects/admin-logout`, {
                method: "POST",
                credentials: "include",
            });

        } catch (error) {

            console.error("Logout error:", error);

        } finally {

            setUser(null);

            window.location.href = "/login";
        }
    };


    return (
        <AdminAuthContext.Provider
            value={{
                user,
                login,
                logout,
                isAuthenticated: !!user,
                loadingAuth,
            }}
        >
            {children}
        </AdminAuthContext.Provider>
    );
};


// ============================================
// Custom Hook
// ============================================
export const useAuth = () => {

    const context = useContext(AdminAuthContext);

    if (!context) {

        throw new Error(
            "useAuth must be used inside AuthProvider"
        );

    }

    return context;
};